import { ApiService } from './index'
import { Device, SensorDefinition, ApiResponse } from '@types'

export const devicesApi = {
  // Devices
  getDevices: () =>
    ApiService.get<ApiResponse<Device[]>>('/devices/'),

  getDevice: (id: number) =>
    ApiService.get<ApiResponse<Device>>(`/devices/${id}/`),

  createDevice: (data: Partial<Device>) =>
    ApiService.post<ApiResponse<Device>>('/devices/', data),

  updateDevice: (id: number, data: Partial<Device>) =>
    ApiService.patch<ApiResponse<Device>>(`/devices/${id}/`, data),

  deleteDevice: (id: number) =>
    ApiService.delete(`/devices/${id}/`),

  // Sensor Definitions
  getSensorDefinitions: (deviceId: number) =>
    ApiService.get<ApiResponse<SensorDefinition[]>>(`/devices/${deviceId}/sensorDefinitions/`),

  getSensorDefinition: (deviceId: number, sensorDefId: number) =>
    ApiService.get<ApiResponse<SensorDefinition>>(`/devices/${deviceId}/sensorDefinitions/${sensorDefId}/`),

  createSensorDefinition: (deviceId: number, data: Partial<SensorDefinition>) =>
    ApiService.post<ApiResponse<SensorDefinition>>(`/devices/${deviceId}/sensorDefinitions/`, data),

  updateSensorDefinition: (deviceId: number, sensorDefId: number, data: Partial<SensorDefinition>) =>
    ApiService.patch<ApiResponse<SensorDefinition>>(`/devices/${deviceId}/sensorDefinitions/${sensorDefId}/`, data),

  deleteSensorDefinition: (deviceId: number, sensorDefId: number) =>
    ApiService.delete(`/devices/${deviceId}/sensorDefinitions/${sensorDefId}/`),

  // Device measurements
  getDeviceMeasurements: (deviceId: number, params?: {
    start?: string
    end?: string
    interval?: string
    limit?: number
  }) =>
    ApiService.get<ApiResponse<any>>(`/devices/${deviceId}/measurements/`, { params }),

  // Device settings
  getDeviceSettings: (deviceId: number) =>
    ApiService.get<ApiResponse<any>>(`/devices/${deviceId}/settings/`),

  updateDeviceSettings: (deviceId: number, data: any) =>
    ApiService.patch<ApiResponse<any>>(`/devices/${deviceId}/settings/`, data),

  // Live device status (online/offline, battery, signal, last-seen)
  getDeviceStatus: (deviceId: number) =>
    ApiService.get<ApiResponse<any>>(`/devices/${deviceId}/status/`),

  // Most recent sensor reading (weight/temperature/humidity)
  getDeviceLatestData: (deviceId: number) =>
    ApiService.get<ApiResponse<any>>(`/devices/${deviceId}/latest-data/`),

  // Historical sensor readings (now served from Postgres, same response shape as before)
  getDeviceHistory: (deviceId: number, params?: { limit?: number }) =>
    ApiService.get<ApiResponse<any[]>>(`/devices/${deviceId}/history/`, { params }),

  restartDevice: (deviceId: number) =>
    ApiService.post<ApiResponse<{ message: string }>>(`/devices/${deviceId}/restart/`),

  triggerMeasurement: (deviceId: number) =>
    ApiService.post<ApiResponse<{ message: string }>>(`/devices/${deviceId}/trigger-measurement/`),

  // Scale calibration - a single endpoint that forwards whatever payload is sent as an MQTT
  // command to the device, used for both the "tare" step and the final known-weight step.
  calibrateDevice: (deviceId: number, data: Record<string, any>) =>
    ApiService.post<ApiResponse<{ message: string }>>(`/devices/${deviceId}/calibrate/`, data),
}
